import React, { useRef } from "react";

export default function SelectMediaModal({ selFiles, setFiles, onNext }) {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files);
    setFiles((prev) => [...prev, ...selected]);
  };

  const removeFile = (indexToRemove) => {
    setFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  return (
    <div className="bg-white dark:bg-dark2 border border-slate-200 dark:border-slate-700 rounded-2xl shadow-xl p-6 md:p-8 max-w-xl mx-auto text-center">
      
      {/* Header */}
      <h3 className="text-xl font-bold text-slate-800 dark:text-white mb-1">
        Create New Event Post
      </h3>
      <p className="text-xs text-slate-500 mb-6">
        Select photo(s) or video(s) to attach to your event.
      </p>

      {/* Hidden File Input */}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        multiple
        accept="image/*,video/*"
        className="hidden"
      />

      {/* Media Selection / Drag-Drop Box */}
      {selFiles.length === 0 ? (
        <div 
          onClick={() => fileInputRef.current?.click()}
          className="border-2 border-dashed border-slate-300 dark:border-slate-600 hover:border-blue-500 rounded-2xl p-10 cursor-pointer transition-colors bg-slate-50 dark:bg-slate-800/50 flex flex-col items-center justify-center gap-3"
        >
          <div className="w-16 h-16 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center text-3xl">
            📷
          </div>
          <div>
            <p className="font-semibold text-slate-700 dark:text-slate-200 text-sm">
              Click to upload photos or videos
            </p>
            <p className="text-xs text-slate-400 mt-1">
              Supports JPG, PNG, MP4, MOV (Recommended aspect ratio 2:1, e.g. 1200x600)
            </p>
          </div>
        </div>
      ) : (
        /* Media Preview Grid */
        <div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6 max-h-80 overflow-y-auto p-1">
            {selFiles.map((file, idx) => {
              const isVideo = file.type.startsWith("video/");
              const previewUrl = URL.createObjectURL(file);

              return (
                <div key={idx} className="relative group aspect-[2/1] rounded-lg overflow-hidden border border-slate-200 bg-slate-900">
                  {isVideo ? (
                    <video src={previewUrl} className="w-full h-full object-cover" />
                  ) : (
                    <img src={previewUrl} alt="Preview" className="w-full h-full object-cover" />
                  )}

                  {/* Overlay Badge for Video */}
                  {isVideo && (
                    <span className="absolute bottom-1 left-1 bg-black/60 text-white text-[10px] px-1.5 py-0.5 rounded">
                      🎥 Video
                    </span>
                  )}

                  {/* Remove Button */}
                  <button
                    type="button"
                    onClick={() => removeFile(idx)}
                    className="absolute top-1 right-1 bg-red-600 text-white w-6 h-6 rounded-full text-xs font-bold flex items-center justify-center opacity-90 hover:opacity-100 shadow"
                  >
                    ✕
                  </button>
                </div>
              );
            })}

            {/* Add More Button inside grid */}
            <button
              type="button"
              onClick={() => fileInputRef.current?.click()}
              className="aspect-[2/1] border-2 border-dashed border-slate-300 dark:border-slate-600 hover:border-blue-500 rounded-lg flex flex-col items-center justify-center text-slate-500 hover:text-blue-500 transition-colors bg-slate-50 dark:bg-slate-800"
            >
              <span className="text-xl">+</span>
              <span className="text-[10px] font-semibold">Add More</span>
            </button>
          </div>

          {/* <p className="text-xs text-blue-500 mb-6">
            💡 Note: For best view, keep image dimension in 2:1 ratio (Ex. 1200 x 600)
          </p> */}
        </div>
      )}

      {/* Action Buttons */}
      <div className="flex items-center justify-between gap-4 mt-6">
        {selFiles.length > 0 && (
          <button
            type="button"
            onClick={() => setFiles([])}
            className="text-xs text-red-500 hover:underline font-medium"
          >
            Clear All
          </button>
        )}

        <button
          type="button"
          disabled={selFiles.length === 0}
          onClick={onNext}
          className={`ml-auto px-8 py-2.5 rounded-full font-bold text-sm transition-all ${
            selFiles.length > 0
              ? "bg-blue-600 text-white hover:bg-blue-700 shadow-md cursor-pointer"
              : "bg-slate-200 text-slate-400 cursor-not-allowed"
          }`}
        >
          Next →
        </button>
      </div>

    </div>
  );
}